module.exports = __webpack_public_path__ + "img/icon1@2x.10d50eb0.png";